import {
  useLazyDownloadInvoicesQuery,
  selectGenerationStateId,
  selectGenerationLoading,
} from '@entities/generation-state';
import { downloadFromUrl } from '@entities/generation-state/api/helpers';
import { useAppSelector } from '@shared/model';
import { FLButton } from '@shared/ui';
import { useState } from 'react';

export const DownloadInvoicesButton = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadInvoicesAsync] = useLazyDownloadInvoicesQuery();
  const stateId = useAppSelector(selectGenerationStateId);
  const isGenerationLoading = useAppSelector(selectGenerationLoading);

  const isButtonDisabled = isDownloading || isGenerationLoading || !stateId;

  const classes = {
    container: 'flex justify-end gap-2 mt-10',
    downloadBtn: {
      container: 'bg-waterspout',
    },
  };

  const handleDownload = async () => {
    const { data } = await downloadInvoicesAsync(stateId);
    const url = data as unknown as string;

    try {
      await downloadFromUrl(url, 'Invoices.zip');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <FLButton
      type="primary"
      text={isDownloading ? 'Processing...' : 'Download Invoices'}
      onClick={() => {
        setIsDownloading(true);
        handleDownload();
      }}
      classes={classes.downloadBtn}
      disabled={isButtonDisabled}
      data-id="button-DownloadInvoices"
    />
  );
};
